export const CUSTOMER_TYPES = [
  { value: 'armaturenhersteller', label: 'Armaturenhersteller', icon: 'mdi-pipe-valve' },
  { value: 'handelsvertreter', label: 'Handelsvertreter', icon: 'mdi-account-tie' },
  { value: 'procurementConstruction', label: 'Procurement Construction (PC)', icon: 'mdi-account-hard-hat' },
  { value: 'endkunde', label: 'Endkunde', icon: 'mdi-domain' }
] as const;

export type CustomerType = typeof CUSTOMER_TYPES[number]['value'];

export type CustomerNavFilter = 'all' | CustomerType | 'unassigned';

export const CUSTOMER_NAV_FILTERS: Array<{ value: CustomerNavFilter; label: string; icon: string }> = [
  { value: 'all', label: 'Kunden', icon: 'mdi-briefcase-outline' },
  { value: 'armaturenhersteller', label: 'Armaturenhersteller', icon: 'mdi-pipe-valve' },
  { value: 'handelsvertreter', label: 'Handelsvertreter', icon: 'mdi-account-tie' },
  { value: 'procurementConstruction', label: 'Procurement Construction (PC)', icon: 'mdi-account-hard-hat' },
  { value: 'endkunde', label: 'Endkunde', icon: 'mdi-domain' },
  { value: 'unassigned', label: 'Ohne Zuweisung', icon: 'mdi-help-circle-outline' }
];

export const VALVE_MAKER_TYPE: CustomerType = 'armaturenhersteller';

export const END_USER_TYPE: CustomerType = 'endkunde';

/** EPC im Projekt ist der Kundenstamm vom Typ Procurement Construction (PC). */
export const EPC_CUSTOMER_TYPE: CustomerType = 'procurementConstruction';

export const isCustomerType = (value: unknown): value is CustomerType =>
  CUSTOMER_TYPES.some((type) => type.value === value);

export const customerTypeNeedsValveMakers = (value?: string | null): boolean =>
  value === 'handelsvertreter' || value === 'procurementConstruction' || value === 'endkunde';

export const customerTypeNeedsEpc = (value?: string | null): boolean =>
  value === 'handelsvertreter' || value === 'armaturenhersteller';

export const customerTypeLabel = (value?: string | null): string =>
  CUSTOMER_TYPES.find((type) => type.value === value)?.label ?? '';

export const customerTypeIcon = (value?: string | null): string =>
  CUSTOMER_TYPES.find((type) => type.value === value)?.icon ?? 'mdi-briefcase-outline';

export const matchesCustomerNavFilter = (customerType: string | null | undefined, filter: CustomerNavFilter): boolean => {
  if (filter === 'all') {
    return true;
  }
  if (filter === 'unassigned') {
    return !isCustomerType(customerType);
  }
  return customerType === filter;
};
